export const usePagination = (currentPage:Ref<number>, limit = 12) => {

    return computed(() => {
        return {
            offset: currentPage.value * limit - limit,
            limit    
        }  
    })
}